import {action, observable} from 'mobx';
import {successAlert} from 'shared/tools';
import {t} from 'shared/core';
import companyStore from 'stores/company/CompanyStore';

class HRDashboardVisibilityState {
  store = companyStore;

  @observable company;

  @action async load() {
    this.company = await this.store.loadCompany();
  }

  @action async updateBirthdayCelebrationVisibility(value) {
    this.company.merge({birthdayCelebrationVisibility: value});
    this.updateCompany();
  }


  @action async updateStartDateCelebrationVisibility(value) {
    this.company.merge({startDateCelebrationVisibility: value});
    this.updateCompany();
  }

  @action async updateAnniversaryCelebrationVisibility(value) {
    this.company.merge({anniversaryCelebrationVisibility: value});
    this.updateCompany();
  }

  @action async updateStaffCountVisibility(value) {
    this.company.merge({staffCountVisibility: value});
    this.updateCompany();
  }

  @action async updatePeopleOffTodayVisibility(value) {
    this.company.merge({peopleOffTodayVisibility: value});
    this.updateCompany();
  }

  @action async updateCompany() {
    const {model, errors} = await this.store.patchCompany(this.company);
    this.errors = errors;

    if (model) {
      successAlert(t('company_settings.hr_dashboard_visibility.Home page settings saved.'));
    }
  }
}

export default HRDashboardVisibilityState;
